import axios, {AxiosInstance, AxiosRequestConfig} from "axios";

const config: AxiosRequestConfig = {
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        Accept: "application/json",
        'content-type': 'application/json',
        "ngrok-skip-browser-warning": 123
    }
}

const api: AxiosInstance = axios.create(config)

export default api
